// extracted by mini-css-extract-plugin
export default {"headerContainer":"Notes_headerContainer__L84ZO","title":"Notes_title__svFKG","content":"Notes_content__J0Eoq"};